module.exports = __webpack_public_path__ + "static/media/logo_eduprime.5717c2dd.png";